import {Language} from "modules/enums";

export const getValueByLang = (value: Record<string, string>, lang: string): string => {
	return value[lang] || value[Language.English] || "";
};
